import React, { Component, createRef } from 'react';
import img2 from '../../assets/images/Traffic.png';
import { apiEndpoint } from 'helpers/url_helper';
import { Table } from "reactstrap";
import Locimagred from '../../assets/images/RedMarker.png';
import Locimaggreen from '../../assets/images/GreenMarker.png';
import Locimagyellow from '../../assets/images/YellowMarker.png';

class CustomTrafficFlow extends Component {
    constructor(props) {
        super(props);
        this.mapRef = createRef();
        this.state = {
            collection: [],
            counts: {},
            activeMarker: null,
            showingInfoWindow: false,
            selectedPlace: null,
            violationCount: 0,
            vehicleCount: 0,
            LastUpadtedTime: '',
            mapBounds: {
                latMin: 10.0,
                latMax: 48.9,
                lngMin: 67.5,
                lngMax: 77.9,
            },
          
            greenThreshold: 8,
            greenMin: 0,
            yellowMin: 9,
            yellowMax: 15,
            redMin: 16,
            redMax: 30,
        };
    }

    componentDidMount() {
        this.fetchLocationData(this.props.CampusID);
        this.fetchFilteredCounts(); 
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.CampusID !== this.props.CampusID ||
            prevProps.fromDate !== this.props.fromDate ||
            prevProps.toDate !== this.props.toDate

        ) {
            this.fetchLocationData(this.props.CampusID);
            this.fetchFilteredCounts();
        }
    }

    fetchLocationData = (intCampusID) => {
        if (!intCampusID) return;
        const url = apiEndpoint + '/GetLocationList';
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                intCampusID,
                strToken: sessionStorage.getItem('Clear_AuthUser'),
            }),
        })
            .then(res => res.json())
            .then(result => {
                const locations = JSON.parse(result.Locations || '[]').map((loc, index) => ({
                    ...loc,
                    manualX: [67, 66, 62, 56, 57.3, 58, 60, 60.3, 62, 63, 61, 68.5, 61.3,66][index],
                    manualY: [75, 73, 82, 55, 52, 48.5, 60, 13, 55, 33, 64, 75, 13,67][index],
                }));
                this.setState({ collection: locations });
            })
            .catch(error => console.error('Error fetching locations:', error));
    };

    fetchFilteredCounts = () => {
        const url = apiEndpoint + '/GetVehicleAndViolationCount'; 
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                intCampusID: this.props.CampusID,
                FromDtTm: this.props.fromDate,
                ToDtTm: this.props.toDate,

                strToken: sessionStorage.getItem('Clear_AuthUser'),
            }),
        })
            .then(res => res.json())
            .then(result => {
                if (result.VehicleCounts) {
                    const countMap = {};
                    result.VehicleCounts.forEach(item => {
                        countMap[item.LocationID] = {
                            violation: item.ViolationCount || 0,
                            vehicle: item.VehicleCount || 0,
                        };
                    });
                    this.setState({ counts: countMap });
                }
                console.log("Date is ", this.props.fromDateTime)
            })
            .catch(error => console.error('Error fetching filtered counts:', error));
    };

    calculatePosition = (lat, lng) => {
        const { latMin, latMax, lngMin, lngMax } = this.state.mapBounds;
        const x = ((lng - lngMin) / (lngMax - lngMin)) * 100;
        const y = ((latMax - lat) / (latMax - latMin)) * 100;
        return { x, y };
    };

    onMarkerClick = (marker) => {
        const { x, y } = this.calculatePosition(marker.Latitude, marker.Longitude);
        this.setState({
            activeMarker: { ...marker, x, y },
            showingInfoWindow: true,
            selectedPlace: marker.LocationName,
            violationCount: 0,
            vehicleCount: 0,
        });

        //  Fetch filtered count for single location
        const url = apiEndpoint + '/GetVehicleAndViolationCount';
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                intCampusID: this.props.CampusID,
                FromDtTm: this.props.fromDate,
                ToDtTm: this.props.toDate,
                strToken: sessionStorage.getItem('Clear_AuthUser'),
            }),
        })
            .then(res => res.json())
            .then(result => {
                if (result.VehicleCounts) {
                    const selected = result.VehicleCounts.find(c => c.LocationID === marker.LocationID);
                    const currentTime = new Date().toLocaleString(undefined, { timeZone: 'Asia/Kolkata' });
                    if (selected) {
                        this.setState({
                            violationCount: selected.ViolationCount || 0,
                            vehicleCount: selected.VehicleCount || 0,
                            LastUpadtedTime: currentTime,
                        });
                    }
                }
            })
            .catch(error => console.error('Error fetching marker data:', error));
    };
    // Update threshold dynamically
    //handleThresholdChange = (e, field) => {
    //    this.setState({ [field]: Number(e.target.value) });
    //};
    //handleThresholdChange = (e, field) => {
    //    let value = parseInt(e.target.value, 10) || 0;
    //    let { greenMin, greenThreshold, yellowMin, yellowMax } = this.state;

    //    if (field === "greenMin") {
    //        // greenMin should never exceed greenThreshold
    //        if (value > greenThreshold) value = greenThreshold;
    //        greenMin = value;
    //    }

    //    if (field === "greenThreshold") {
    //        // greenThreshold should always be less than yellowMax
    //        if (value >= yellowMax) value = yellowMax - 1;
    //        greenThreshold = value;

    //        // auto adjust yellowMin to be greenThreshold + 1
    //        yellowMin = greenThreshold + 1;
    //    }

    //    if (field === "yellowMin") {
    //        // yellowMin must always be > greenThreshold
    //        if (value <= greenThreshold) value = greenThreshold + 1;
    //        // cannot exceed yellowMax
    //        if (value > yellowMax) value = yellowMax;
    //        yellowMin = value;
    //    }

    //    if (field === "yellowMax") {
    //        // yellowMax must always be > yellowMin
    //        if (value <= yellowMin) value = yellowMin + 1;
    //        yellowMax = value;
    //    }

    //    this.setState({ greenMin, greenThreshold, yellowMin, yellowMax });
    //};

   
    handleThresholdChange = (e, field) => {
        let raw = e.target.value;


        if (raw === "") {
            this.setState({ [field]: "", yellowMaxError: false, redMaxError: false });
            return;
        }

        let value = parseInt(raw, 10);
        if (isNaN(value)) return;

        let { greenMin, greenThreshold, yellowMin, yellowMax, redMax, redMin } = this.state;
        let yellowMaxError = false;
        let redMaxError = false;

        if (field === "greenMin") {
            if (value > greenThreshold) value = greenThreshold;
            greenMin = value;
        }

        if (field === "greenThreshold") {
            if (value >= yellowMax) yellowMax = value + 1;
            greenThreshold = value;
            yellowMin = greenThreshold + 1;

            if (yellowMin >= yellowMax) yellowMax = yellowMin + 1;
            if (yellowMax >= redMin) redMin = yellowMax + 1;
            if (redMin >= redMax) redMax = redMin + 1;
        }

        if (field === "yellowMin") {
            if (value <= greenThreshold) value = greenThreshold + 1;
            if (value >= yellowMax) yellowMax = value + 1;
            yellowMin = value;
            if (yellowMax >= redMin) redMin = yellowMax + 1;
        }

        if (field === "yellowMax") {
            yellowMax = value;

            // validation
            if (yellowMax <= yellowMin) {
                yellowMaxError = true;
            }

            if (yellowMax >= redMin) {
                redMin = yellowMax + 1;
            }

        
            if (yellowMax < redMin) {
                redMin = yellowMax + 1;
            }

            
            if (redMin >= redMax) {
                redMax = redMin + 1;
            }
        }

        if (field === "redMin") {
            redMin = value;

            if (redMin >= redMax) {
                redMax = redMin + 1;
            }

           
            if (redMin < yellowMax + 1) {
                redMin = yellowMax + 1;  
            }
        }


        if (field === "redMax") {
            redMax = value;

        
            if (redMax <= redMin) {
                redMaxError = true;
            }
        }

        this.setState({ greenMin, greenThreshold, yellowMin, yellowMax, redMin, redMax, yellowMaxError, redMaxError });
    };

    closeInfoWindow = () => {
        this.setState({ showingInfoWindow: false, activeMarker: null });
    };

    renderMarkers = () => {
        const { greenThreshold, yellowMin, yellowMax,redMin, redMax } = this.state;
        return this.state.collection.map((marker, index) => {
            const countData = this.state.counts[marker.LocationID] || { vehicle: 0 };
            const x = marker.manualX ?? this.calculatePosition(marker.Latitude, marker.Longitude).x;
            const y = marker.manualY ?? this.calculatePosition(marker.Latitude, marker.Longitude).y;

            let markerColor = '';
            if (countData.vehicle <= greenThreshold) {
                markerColor = Locimaggreen;
            } else if (countData.vehicle >= yellowMin && countData.vehicle <= yellowMax) {
                markerColor = Locimagyellow;
            } else {
                markerColor = Locimagred;
            }

            const isActive = this.state.activeMarker?.LocationID === marker.LocationID;

            return (
                <React.Fragment key={index}>
                    <div
                        style={{
                            position: 'absolute',
                            left: `${x}%`,
                            top: `${y - 1}%`,
                            width: '40px',
                            height: '40px',
                            backgroundImage: `url(${markerColor})`,
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            transform: 'translate(-50%, -50%)',
                            cursor: 'pointer',
                        }}
                        title={`${marker.LocationName} Violations: ${countData.violation}`}
                        onClick={() => this.onMarkerClick({ ...marker, x, y })}
                    ></div>

                    {isActive && this.state.showingInfoWindow && (
                        <div
                            style={{
                                position: 'absolute',
                                left: `${x}%`,
                                top: `${y}%`,
                                transform: 'translate(-50%, -120%)',
                                backgroundColor: '#fff',
                                padding: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                minWidth: '150px',
                                zIndex: 10,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                            }}
                            className="custom-info-window"
                        >
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "-10px",
                                    left: "49%",
                                    transform: "translateX(-50%)",
                                    width: 0,
                                    height: 0,
                                    borderLeft: "10px solid transparent",
                                    borderRight: "10px solid transparent",
                                    borderTop: "10px solid #fff",
                                }}
                            />
                            <span
                                onClick={this.closeInfoWindow}
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    color: "black",
                                    cursor: "pointer",
                                }}
                            >
                                &times;
                            </span>
                            <div className="table-responsive">
                                <Table className="table mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{ fontSize: "10px" }}>{this.state.selectedPlace}</th>
                                            <td style={{ fontSize: "smaller" }}>
                                                Last Updated: {this.state.LastUpadtedTime}
                                            </td>
                                        </tr>
                                    </thead>
                                </Table>
                                <Table className="table mb-0">
                                    <tbody>
                                        <tr className="table-warning">
                                            <td colSpan="2">Violation Count</td>
                                            <td colSpan="2">Vehicle Count</td>
                                        </tr>
                                        <tr className="table-info">
                                            <td colSpan="2">{this.state.violationCount}</td>
                                            <td colSpan="2">{this.state.vehicleCount}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            );
        });
    };

    render() {
        return (
            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                <img src={img2} alt="Static Map" ref={this.mapRef} style={{ width: '100%', height: '100%' }} />
                {this.renderMarkers()}

                {/* Legend with editable thresholds */}
                {/*<div*/}
                {/*    style={{*/}
                {/*        position: 'absolute',*/}
                {/*        top: '10px',*/}
                {/*        left: '10px',*/}
                {/*        backgroundColor: 'white',*/}
                {/*        padding: '8px 12px',*/}
                {/*        borderRadius: '8px',*/}
                {/*        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',*/}
                {/*        fontSize: '12px',*/}
                {/*        zIndex: 1000,*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>*/}
                {/*        <img src={Locimaggreen} alt="Green" style={{ width: '20px', height: '20px', marginRight: '6px' }} />*/}
                {/*        <span>Vehicle Count &lt;= </span>*/}
                {/*        <input*/}
                {/*            type="number"*/}
                {/*            value={this.state.greenThreshold}*/}
                {/*            onChange={(e) => this.handleThresholdChange(e, "greenThreshold")}*/}
                {/*            style={{ width: "40px", marginLeft: "5px" }}*/}
                {/*        />*/}
                {/*    </div>*/}

                {/*    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>*/}
                {/*        <img src={Locimagyellow} alt="Yellow" style={{ width: '20px', height: '20px', marginRight: '6px' }} />*/}
                {/*        <input*/}
                {/*            type="number"*/}
                {/*            value={this.state.yellowMin}*/}
                {/*            onChange={(e) => this.handleThresholdChange(e, "yellowMin")}*/}
                {/*            style={{ width: "40px", marginLeft: "5px" }}*/}
                {/*        />*/}
                {/*        <span> &lt;= Vehicle Count &lt;= </span>*/}
                {/*        <input*/}
                {/*            type="number"*/}
                {/*            value={this.state.yellowMax}*/}
                {/*            onChange={(e) => this.handleThresholdChange(e, "yellowMax")}*/}
                {/*            style={{ width: "40px", marginLeft: "5px" }}*/}
                {/*        />*/}

                {/*    </div>*/}

                {/*    <div style={{ display: 'flex', alignItems: 'center' }}>*/}
                {/*        <img src={Locimagred} alt="Red" style={{ width: '20px', height: '20px', marginRight: '6px' }} />*/}
                {/*        <span>Vehicle Count &gt;</span>*/}
                {/*        <input*/}
                {/*            type="number"*/}
                {/*            value={this.state.yellowMax}*/}
                {/*            onChange={(e) => this.handleThresholdChange(e, "yellowMax")}*/}
                {/*            style={{ width: "40px", marginLeft: "5px" }}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div
                    style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        zIndex: 1000,
                        fontSize: '12px',
                    }}
                >
                    <table
                        style={{
                            borderCollapse: "collapse",
                            fontSize: "12px",
                            textAlign: "center",
                            backgroundColor: "white",   
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)", 
                            overflow: "hidden",
                        }}
                    >
                        <thead>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <th style={{ border: "1px solid #ccc", padding: "4px" }}>Symbol</th>
                                <th style={{ border: "1px solid #ccc", padding: "4px" }}>Vehicle Count</th>
                                <th style={{ border: "1px solid #ccc", padding: "4px" }}>Range</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Green Row */}
                            <tr>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                                    <img src={Locimaggreen} alt="Green" style={{ width: '18px', height: '18px' }} />
                                </td>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>Normal</td>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                                    <input
                                        type="number"
                                        value={this.state.greenMin}
                                        onChange={(e) => this.handleThresholdChange(e, "greenMin")}
                                        style={{ width: "50px" }}
                                        readOnly
                                    />{" "}
                                    -{" "}
                                    <input
                                        type="number"
                                        min="0"
                                        value={this.state.greenThreshold}
                                        onChange={(e) => this.handleThresholdChange(e, "greenThreshold")}
                                        style={{ width: "50px" }}
                                    />
                                </td>
                            </tr>

                            {/* Yellow Row */}
                            <tr>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                                    <img src={Locimagyellow} alt="Yellow" style={{ width: '18px', height: '18px' }} />
                                </td>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>Moderate</td>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                                    <input
                                        type="number"
                                        value={this.state.yellowMin}
                                        onChange={(e) => this.handleThresholdChange(e, "yellowMin")}
                                        style={{ width: "50px" }}
                                    />{" "}-{" "}
                                    <input
                                        type="number"
                                        value={this.state.yellowMax}
                                        onChange={(e) => this.handleThresholdChange(e, "yellowMax")}
                                        style={{
                                            width: "50px",
                                            border: this.state.yellowMaxError ? "2px solid red" : "1px solid #676464",
                                            outline: "none",
                                        }}
                                    />
                                </td>
                            </tr>

                            {/* Red Row */}
                            <tr>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                                    <img src={Locimagred} alt="Red" style={{ width: '18px', height: '18px' }} />
                                </td>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>High</td>
                                <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                                    <input
                                        type="number"
                                        value={this.state.redMin ?? ""}
                                        onChange={(e) => this.handleThresholdChange(e, "redMin")}
                                        style={{ width: "50px" }}
                                    />{" "}-{" "}
                                    <input
                                        type="number"
                                        value={this.state.redMax}
                                        onChange={(e) => this.handleThresholdChange(e, "redMax")}
                                        style={{
                                            width: "50px",
                                            border: this.state.redMaxError ? "2px solid red" : "1px solid #676464",
                                            outline: "none",
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default CustomTrafficFlow;
